import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RaToastService } from '@shared/components';

/**
 * "Desfazer" para o que se apaga DENTRO de um card (linha da tabela, item do semáforo,
 * indicador): a remoção vale na hora e é gravada, e o toast oferece voltar atrás por
 * alguns segundos. Quem desfaz reinsere no lugar de origem e grava de novo. É o irmão
 * menor do FieldRemovalService, que segura a remoção do CARD inteiro até a janela fechar.
 */
@Injectable({ providedIn: 'root' })
export class UndoToastService {
    private static readonly DURATION_MS = 6000;

    private _toast = inject(RaToastService);
    private _translate = inject(TranslateService);
    private _lastId: string | null = null;

    /** Mostra "X removido" com Desfazer; um novo aviso substitui o anterior. */
    public show(messageKey: string, onUndo: () => void): void {
        if (this._lastId) this._toast.dismiss(this._lastId);

        const id = this._toast.show({
            type: 'info',
            variant: 'pill',
            message: this._translate.instant(messageKey),
            duration: UndoToastService.DURATION_MS,
            action: {
                label: this._translate.instant('common.undo'),
                handler: () => {
                    this._toast.dismiss(id);
                    if (this._lastId === id) this._lastId = null;
                    onUndo();
                },
            },
        });
        this._lastId = id;
    }
}
